import React from 'react';
import routes from 'src/constants/routes';
import Text from 'src/components/Text';
import ScrollAnchor from 'src/components/ScrollAnchor';
import img1 from './images/1.png';
import img2 from './images/2.png';
import img3 from './images/3.png';
import img4 from './images/4.png';
import img5 from './images/5.png';
import img6 from './images/6.png';
import img7 from './images/7.png';
import img8 from './images/8.png';
import img9 from './images/9.png';
import img10 from './images/10.png';
import img11 from './images/11.png';
import img12 from './images/12.png';
import img13 from './images/13.png';
import img14 from './images/14.png';
import img15 from './images/15.png';
import img16 from './images/16.png';
import img17 from './images/17.png';
import img18 from './images/18.png';
import img19 from './images/19.png';
import img20 from './images/20.png';
import img21 from './images/21.png';
import img22 from './images/22.png';
import img23 from './images/23.png';
import img24 from './images/24.png';
import img25 from './images/25.png';
import img26 from './images/26.png';
import styles from './styles.module.scss';

const Help: React.FC = () => {
  return (
    <div className={styles['root']}>
      <a href="/SBP_agent_instruction.pdf" className={styles['pdf-link']} download>Скачать инструкцию</a>
      <ScrollAnchor anchor="1">
        <Text type="h1">1. Подключение к Агенту 1С:СБП</Text>
      </ScrollAnchor>
      <ScrollAnchor anchor="1.1">
        <Text type="h2">1.1. Как зарегистрироваться в Агенте 1С:СБП</Text>
      </ScrollAnchor>
      <Text type="p">Если у вас еще нет учетной записи, нажмите кнопку “Зарегистрироваться”.</Text>
      <img src={img1} alt="" className={styles['img']}/>
      <Text type="p">
        Действия по регистрации выполняются последовательно. После ввода данных для перехода к следующему шагу
        используйте кнопку «Продолжить».
      </Text>
      <Text type="p">
        Для регистрации в поле «Номер телефона» введите доступный вам номер телефона в формате: код страны/ код
        сети / номер телефона / + 7999ХХХХХХХ.
      </Text>
      <img src={img2} alt="" className={styles['img']}/>
      <Text type="p">
        На указанный номер будет направлено СМС-сообщение с кодом подтверждения. Введите полученный код.
      </Text>
      <img src={img3} alt="" className={styles['img']}/>
      <Text type="p">
        Придумайте и введите уникальный пароль, который вы сможете запомнить и использовать в дальнейшем при работе
        в Агенте 1С:СБП.
      </Text>
      <img src={img4} alt="" className={styles['img']}/>
      <Text type="p">
        Заполните данные в профиле. Для завершения регистрации необходимо подтверждение согласия на обработку
        персональных данных.
      </Text>
      <img src={img5} alt="" className={styles['img']}/>
      <Text type="p">
        Регистрация успешно завершена. На указанный e-mail автоматически отправляется письмо для подтверждения
        адреса электронной почты. По подтверждённому адресу в дальнейшем можно будет при необходимости восстановить
        пароль для входа в личный кабинет. Для перехода в личный кабинет нажмите «Войти».
      </Text>
      <img src={img6} alt="" className={styles['img']}/>
      <ScrollAnchor anchor="1.2">
        <Text type="h2">1.2. Как восстановить пароль</Text>
      </ScrollAnchor>
      <Text type="p">
        Для входа в Агент 1C:СБП на главной странице нажмите “Войти” и  введите номер телефона и пароль, которые вы
        использовали при регистрации. Если вы забыли свой пароль, нажмите на ссылку “Забыли пароль?” и следуйте
        дальнейшим инструкциям.
      </Text>
      <img src={img7} alt="" className={styles['img']}/>
      <Text type="p">
        Действия по восстановлению пароля выполняются последовательно. После ввода данных для перехода к следующему шагу
        используйте кнопку «Продолжить».
      </Text>
      <Text type="p">
        В поле «Номер телефона» введите номер, с которым вы регистрировались в Агенте 1С:СБП. Выберите метод
        восстановления, установив соответствующий переключатель. Вы сможете получить код на e-mail только, если
        адрес электронной почты был подтвержден.
      </Text>
      <img src={img8} alt="" className={styles['img']}/>
      <Text type="p">Введите код, полученный выбранным способом.</Text>
      <img src={img9} alt="" className={styles['img']}/>
      <Text type="p">Создайте новый пароль.</Text>
      <img src={img10} alt="" className={styles['img']}/>
      <Text type="p">Пароль успешно изменен. Для перехода в личный кабинет нажмите «Войти».</Text>
      <img src={img11} alt="" className={styles['img']}/>
      <ScrollAnchor anchor="2">
        <Text type="h1">2. Работа с организацией</Text>
      </ScrollAnchor>
      <Text type="p">
        Для выполнения некоторых операций в Агенте 1С:СБП требуется дополнительная аутентификация по СМС. Процесс
        аутентификации происходит по телефонному номеру, с которым была произведена авторизация на сайте.
      </Text>
      <ScrollAnchor anchor="2.1">
        <Text type="h2">2.1. Как добавить организацию</Text>
      </ScrollAnchor>
      <Text type="p">
        Для того, чтобы самостоятельно добавить новую организацию для работы в Агенте 1С:СБП, необходимо  подтверждение
        принадлежности к этой организации с помощью электронной подписи.
      </Text>
      <Text type="p">Нажмите на кнопку «Добавить организацию» в личном кабинете.</Text>
      <img src={img12} alt="" className={styles['img']}/>
      <Text type="p">На форме проверки электронной подписи выберите подходящий вариант для подтверждения.</Text>
      <img src={img13} alt="" className={styles['img']}/>
      <Text type="p">Для завершения подтверждения указанным способом необходимо принять условия договора оферты.</Text>
      <img src={img14} alt="" className={styles['img']}/>
      <Text type="p">После успешного подтверждения организация появится в личном кабинете.</Text>
      <ScrollAnchor anchor="2.2">
        <Text type="h2">2.2. Как пригласить пользователя в организацию</Text>
      </ScrollAnchor>
      <Text type="p">
        Для того, чтобы присоединиться к организации, не подтверждая свою принадлежность через электронную подпись,
        пользователю можно отправить ссылку–приглашение.
      </Text>
      <Text type="p">
        На странице организации нужно перейти на вкладку «Пользователи» и нажать «Пригласить пользователя».
      </Text>
      <img src={img15} alt="" className={styles['img']}/>
      <Text type="p">
        На форме приглашения в поле E-mail введите адрес почты пользователя. В поле «Введите символы» введите код с
        картинки. Если вы не можете разобрать символы на картинке, кликните на знак «Обновить» в правом верхнем углу
        поля с символами и введите новый код. Нажмите «Отправить».
      </Text>
      <img src={img16} alt="" className={styles['img']}/>
      <Text type="p">Пользователь получит письмо на указанный адрес с темой «Приглашение в организацию».</Text>
      <ScrollAnchor anchor="2.3">
        <Text type="h2">2.3. Как пройти аутентификацию в Агенте 1С:СБП по ссылке-приглашению</Text>
      </ScrollAnchor>
      <Text type="p">
        Чтобы принять приглашение, перейдите по ссылке из полученного письма с темой «Приглашение в организацию».
      </Text>
      <Text type="p">На форме приглашения:</Text>
      <ul>
        <li>
          <Text type="p">
            если вы ранее зарегистрировались в 1C:СБП Агенте, то нажмите на кнопку “Войти” и введите номер телефона
            и пароль, которые были использованы при регистрации
          </Text>
        </li>
        <li>
          <Text type="p">
            если у вас еще нет учетной записи, нажмите кнопку “Зарегистрироваться” и следуйте дальнейшим{' '}
            <a href={`${routes.help}#1.1`}>инструкциям</a>.
          </Text>
        </li>
      </ul>
      <img src={img17} alt="" className={styles['img']}/>
      <Text type="p">
        После успешной авторизации организация появится в личном кабинете. Новый пользователь появится в списке
        пользователей этой организации.
      </Text>
      <ScrollAnchor anchor="2.4">
        <Text type="h2">2.4. Как удалить пользователя из организации</Text>
      </ScrollAnchor>
      <Text type="p">
        Пользователь, который подтвердил свою связь с организацией с помощью цифровой подписи, может удалять любых
        пользователей из организации без ограничений. Пользователи, которые не подтвердили свою принадлежность
        с помощью цифровой подписи, могут удалять только других пользователей, которые также не подтвердили свою связь.
        Чтобы удалить пользователя, нажмите на ссылку “Удалить” в колонке “Действие” в строке с данными пользователя.
      </Text>
      <img src={img18} alt="" className={styles['img']}/>
      <ScrollAnchor anchor="2.5">
        <Text type="h2">2.5. Как добавить банк к организации</Text>
      </ScrollAnchor>
      <Text type="p">На странице организации нужно перейти на вкладку «Банки» и нажать «Добавить банк».</Text>
      <img src={img19} alt="" className={styles['img']}/>
      <Text type="p">
        На форме добавления банка введите БИК или название банка и номер расчётного счёта в одноименных полях.
        Нажмите «Добавить».
      </Text>
      <img src={img20} alt="" className={styles['img']}/>
      <Text type="p">
        После ввода данных система отправляет запрос в Оперативно-платежный и клиринговый центр Системы быстрых
        платежей (ОПКЦ) с использованием ОГРН организации и данных с формы, и ищет список торгово-сервисных предприятий
        (ТСП), соответствующих этим данным.
      </Text>
      <Text type="p">
        Если данные успешно найдены, то новый банк добавляется к организации. В разделе “Банки” на странице организации
        появится информация о новом банке.
      </Text>
      <img src={img21} alt="" className={styles['img']}/>
      <Text type="p">
        Если информация о ТСП отсутствует в ОПКЦ для этой организации и банка, то на форме добавления нового банка
        появится предупреждающее сообщение о том, что информация о ТСП для организации в банке не найдена. Банк
        добавлен не будет.
      </Text>
      <img src={img22} alt="" className={styles['img']}/>
      <ScrollAnchor anchor="2.6">
        <Text type="h2">2.6. Как удалить банк из организации</Text>
      </ScrollAnchor>
      <Text type="p">На странице банка нажмите на ссылку “Удалить” в колонке “Действие” в строке с данными банка.</Text>
      <Text type="p">
        После удаления банка управление списком ТСП и получение токенов для этой организации и банка станет недоступно.
        Выпущенные до удаления банка токены для ТСП станут недействительными. При повторном добавлении этого банка
        к организации список ТСП обновится. Потребуется получение новых токенов.
      </Text>
      <img src={img23} alt="" className={styles['img']}/>
      <ScrollAnchor anchor="2.7">
        <Text type="h2">2.7. Как выйти из организации</Text>
      </ScrollAnchor>
      <Text type="p">Выйти из организации можно двумя способами:</Text>
      <ul>
        <li>
          <Text type="p">
            по ссылке «Выйти из организации» в колонке «Действие» в строке со своими данными на странице «Пользователи»;
          </Text>
        </li>
        <li>
          <Text type="p">
            по ссылке «Выйти из организации» на странице «Банки».
          </Text>
        </li>
      </ul>
      <ScrollAnchor anchor="3">
        <Text type="h1">3. Управление токенами</Text>
      </ScrollAnchor>
      <Text type="p">
        Все операции с токенами осуществляются на странице со списком ТСП. Чтобы перейти на эту страницу, необходимо
        сначала перейти на страницу банка, а затем перейти по ссылке “Список ТСП”.
      </Text>
      <img src={img24} alt="" className={styles['img']}/>
      <Text type="p">На странице отображается список ТСП, который приходит из ОПКЦ для выбранной организации и банка.</Text>
      <Text type="p">Для получения актуального списка ТСП нажмите «Обновить» в правой части над таблицей с данными.</Text>
      <Text type="p">
        <span style={{ color: 'green' }}>Зелёным</span> цветом выделяются новые ТСП, по которым токены не выпускались.
        Чтобы получить токен нажмите «Получить токен» в колонке “Действие” в строке с данными ТСП.
      </Text>
      <Text type="p">
        <span style={{ color: 'gray' }}>Серым</span> цветом выделяются ТСП с выпущенными токенами. Выпущенный токен
        можно «Отозвать» или «Перевыпустить».
      </Text>
      <Text type="p">
        <span style={{ color: 'red' }}>Красным</span> цветом выделяются недействительные ТСП. Такие ТСП можно только
        удалить из списка.
      </Text>
      <img src={img25} alt="" className={styles['img']}/>
      <Text type="p">
        При получении или перевыпуске токена открывается форма со сформированным токеном для выбранного ТСП. Скопируйте
        токен по кнопке «Копировать» и вставьте его в форму настройки СБП в программе. После закрытия окна получить
        повторно этот токен будет невозможно. Потребуется перевыпуск нового токена.
      </Text>
      <img src={img26} alt="" className={styles['img']}/>
    </div>
  );
};

export default Help;
